import Head from 'expo-router/head';

import { PublicContentLibraryItem } from '@/components/publicContentLibraryItem';

/**
 * No `ContentLibraryGate` here: the share token itself is the access grant
 * (see `PublicContentLibraryItem`'s JSDoc), so a visitor following a shared
 * link must never be stopped by the clinician attestation question.
 */
export default function ContentLibrarySharedRoute() {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>

      <PublicContentLibraryItem />
    </>
  );
}
